// Sentiment insights is generally available; the hook is kept so call sites
// (including positional args to column builders) stay unchanged.
export function useIsSentimentInsightsEnabled() {
  return true;
}
